import { SceneFactory } from './scene_factory';
import { IResourceCache } from '@cgs/wge';

export const SCENE_COMMON_TOKEN = Symbol('SCENE_COMMON_TOKEN');

export class SceneCommon {
  public readonly sceneFactory: SceneFactory;
  public readonly resourceCache: IResourceCache;

  constructor(sceneFactory: SceneFactory, resourceCache: IResourceCache) {
    this.sceneFactory = sceneFactory;
    this.resourceCache = resourceCache;
  }
}
